import styled from '@emotion/styled';
import { Css, Responsive } from '@/ui';
import isPropValid from '@emotion/is-prop-valid';
import { Shadow } from '../../../../styles/Shadow';
import { Color } from '../../../../styles/Color';
import { Z_INDEX_NAV_WRAPPER } from '../../../../styles/zIndex';

export const List = styled.ul`
	display: flex;
	justify-content: space-between;
	align-items: center;
	list-style-type: none;
	padding: ${Css.pxToRem(8)};
	margin: 0;
	pointer-events: all;
	background: ${Color.PrimaryWhite};
	border-radius: 9999px;
	box-shadow: ${Shadow.Medium};

	& > li {
		margin: 0;
		padding: 0;
	}
`;

export const Wrapper = styled('div', { shouldForwardProp: isPropValid })`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
	top: 0;
	left: 0;
	right: 0;
	z-index: ${Z_INDEX_NAV_WRAPPER};
	pointer-events: none;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: ${Css.pxToRem(12)};
	padding-top: ${Css.pxToRem(16)};
	flex-direction: column;
`;
